import { defaultDougnutDatasetOptions, defaultDougnutOptions, getColors } from '@/utils/analytics'

/**
 * @param {vueInstance} context - This.
 * @returns {DoughnutChart} The chart configuration object.
 */
export default function (context) {
  return {
    key: 'salesgrade',
    resource: {
      endpoint: 'salesgrade_by_turnover',
      filter: {
        'filter.statuses': ['sold', 'sale', 'reserved'],
      },
    },
    type: 'Doughnut',
    title: {
      label: `${context.$t('statisticsSalesResidentials')}`,
      style: true,
    },
    total: ({ data = {} }) => `${Math.round(data.total * 100)} %`,
    data: props => {
      const { data = {}, colors, dimensions = [] } = props
      return {
        labels: dimensions.map(dimension => dimension.label),
        datasets: [
          {
            ...defaultDougnutDatasetOptions,
            backgroundColor: data && data.keys ? data.keys.map(key => colors[key]) : [],
            data: data.values,
          },
        ],
      }
    },
    options: defaultDougnutOptions,
    colors: ({ data = {} }) => getColors(data.keys, true),
    dimensions: ({ data = {}, colors = {} }) =>
      data && data.keys
        ? data.keys.map((key, i) => ({
            id: key,
            label: context.getTranslation(key),
            value: context.valueParser(data.values[i], { notation: 'compact' }),
            marker: colors[key],
            icon: '',
          }))
        : [],
    heading: { label: context.$t('statisticsSalesResidentials'), style: '', icon: '' },
  }
}
